import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckedIcon from "../../../../Img/checked-icon.png";
import RightArrowImg from "../../../../Img/button-arrow.png";
import { formatDateToDDMMYYYY } from "utils/CommonFunctions";
import EditIconImg from "../../../../Img/edit-patient-icon.png";
import ViewIconImg from "../../../../Img/view-patient-details.png";

import { PlusOutlined } from "@ant-design/icons";
import EmbryoBank from "../../../../Img/embryo-bank.png";
import { sendDataToSocket } from "socket/SocketComponent";
import LutealPhase from "../../../../Img/luteal-phase.png";
import AddDocuments from "../../../../Img/add-documents.png";
import CycleOutCome from "../../../../Img/cycle-out-come.png";
import IVFFlowSheet from "../../../../Img/IVF-flow-sheet.png";
import SemenAnalysis from "../../../../Img/semen-analysis.png";
import DischargeCard from "../../../../Img/discharge-card.png";
import PGSDischargeCard from "../../../../Img/PGS-discharge-card.png";
import PatientRegistration from "../../../../Img/patient-registration.png";
import EmbryologyDataSheet from "../../../../Img/embryology-data-sheet.png";
import PatientBasicHistory from "../../../../Img/patient-basic-history.png";
import TimelineDataNoFound from "../../../../Img/timeline-data-no-found.png";
import { setPatientEdit } from "redux/reducers/SearchPanel/globalSearch.slice";
import TESAPESADischargeCard from "../../../../Img/TESAPESA-discharge-card.png";
import PatientExtendedHistory from "../../../../Img/patient-extended-history.png";
import DarkTimelineDataNoFound from "../../../../Img/dark-timeline-data-no-found.png";
import MaleInfertilityInvestigation from "../../../../Img/male-infertility-investigation.png";
import FemaleInfertilityInvestigation from "../../../../Img/female-infertility-investigation.png";
import {
  getPermissionLocationWise,
  setSelectedLocation,
} from "redux/reducers/Role/role.slice";
import { useNavigate } from "react-router-dom";
import DNAModal from "./PatientJourneyModal/DNAModal";
import IUIModal from "./PatientJourneyModal/IUIModal";
import SFreezingModal from "./PatientJourneyModal/SFreezingModal";
import { setSelectedModuleTab, setSelectedPatient } from "redux/reducers/common.slice";
import IvfFlowSheetModal from "./PatientJourneyModal/IvfFlowSheetModal";
import SemenAnalysisModal from "./PatientJourneyModal/SemenAnalysisModal";
import {
  dashboardViewPatientInfo,
  setActivePatientJourneyModuleDetails,
} from "redux/reducers/Dashboard/dashboard.slice";
import EmbryologyDataSheetModal from "./PatientJourneyModal/EmbryologyDataSheetModal";
import PatientRegistrationModal from "./PatientJourneyModal/PatientRegistrationModal";
import PatientBasicHistoryModal from "./PatientJourneyModal/PatientBasicHistoryModal";
import PatientExtendedHistoryModal from "./PatientJourneyModal/PatientExtendedHistoryModal";
import MaleInfertilityInvestigationModal from "./PatientJourneyModal/MaleInfertilityInvestigationModal";
import FemaleInfertilityInvestigationModal from "./PatientJourneyModal/FemaleInfertilityInvestigationModal";
import SSTModal from "./PatientJourneyModal/SSTModal";
import DischargeCardModal from "./PatientJourneyModal/DischargeCardModal";
import LutealPhaseModal from "./PatientJourneyModal/LutealPhaseModal";
import EmbryoBankModal from "./PatientJourneyModal/EmbryoBankModal";
import CycleOutComeModal from "./PatientJourneyModal/CycleOutComeModal";
import PGTDischargeCardModal from "./PatientJourneyModal/PGTDischargeCardModal";
import TesaPesaDischargeCardModal from "./PatientJourneyModal/TesaPesaDischargeCardModal";

const handleModuleWiseIcon = (icon) => {
  switch (icon) {
    case 1:
      return PatientRegistration;
    case 2:
      return PatientBasicHistory;
    case 3:
      return PatientExtendedHistory;
    case 4:
      return MaleInfertilityInvestigation;
    case 5:
      return FemaleInfertilityInvestigation;
    case 6:
      return IVFFlowSheet;
    case 7:
      return EmbryologyDataSheet;
    case 8:
      return SemenAnalysis;
    case 9:
      return DischargeCard;
    case 10:
      return LutealPhase;
    case 11:
      return EmbryoBank;
    case 12:
      return CycleOutCome;
    case 13:
      return PGSDischargeCard;
    case 14:
      return TESAPESADischargeCard;
    case 15:
      return AddDocuments;
    default:
      return PatientRegistration;
  }
};

const PhasePatientList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const defaultTheme = localStorage.getItem("default-theme") || "light";

  const [theme, setTheme] = useState(defaultTheme);
  const [activeModuleEntry, setActiveModuleEntry] = useState({});

  const { moduleList, selectedLocation } = useSelector(({ role }) => role);
  const { activePatient, selectedPatientJourneyInfo } = useSelector(
    ({ dashboard }) => dashboard
  );

  const { patient = {}, completed_pages = [] } = selectedPatientJourneyInfo;

  useEffect(() => {
    const interval = setInterval(() => {
      const current = localStorage.getItem("default-theme");
      if (current !== theme) {
        setTheme(current);
      }
    }, 5);
    return () => clearInterval(interval);
  }, [theme]);

  const onShowModuleDetail = (module, moduleEntry) => {
    setActiveModuleEntry(module.name);

    const selectedModule =
      moduleList?.find((item) => {
        if (item?.submenu?.length > 0) {
          return item?.submenu?.find((subMenu) => {
            return (
              subMenu?.module_actual_name?.toLowerCase() ===
              module?.name?.toLowerCase()
            );
          });
        }
        return (
          item?.module_actual_name?.toLowerCase() ===
          module?.name?.toLowerCase()
        );
      }) || {};

    const payload = {
      type: module.name,
      location_id: selectedLocation,
      patient_reg_id: activePatient._id,
      // patient_reg_id: "666c2455f471447f9e671510",
      ivf_flow_id: moduleEntry.ivf_flow_id,
      module_id: selectedModule?._id,
      _id: moduleEntry._id,
    };

    dispatch(setActivePatientJourneyModuleDetails({}));
    dispatch(dashboardViewPatientInfo(payload));
  };

  const moduleRedirectOnNextStep = () => {
    dispatch(setSelectedPatient(activePatient));

    dispatch(setPatientEdit(activePatient));
    localStorage.setItem(
      "userLocation",
      window.btoa(JSON.stringify(activePatient.location_id))
    );
    sendDataToSocket("JUR", {
      room_id: activePatient.location_id,
    });
    dispatch(setSelectedLocation(activePatient.location_id));
    dispatch(getPermissionLocationWise(activePatient.location_id));
  };

  const handleEditModuleForSelectedPatient = (module, moduleEntry) => {
    moduleRedirectOnNextStep();

    if (module?.name === "IUI") {
      navigate("/iui-h-d", { state: { journey: "/iui-h-d" } });
    } else {
      navigate(module?.path, { state: { journey: module?.path } });
    }
  };

  const onRedirectForCreatePatient = () => {
    navigate("/patient-registration");

    dispatch(setSelectedModuleTab("2"));
  };

  return (
    <>
      <div className="patient-journey">
        {!Object.keys(activePatient)?.length ? (
          <div className="no-data">
            <div className="timeline-data-img">
              <img
                src={
                  theme === "light"
                    ? TimelineDataNoFound
                    : DarkTimelineDataNoFound
                }
                alt="timeline-data-no-found"
              />
            </div>
            <button
              className="btn_primary"
              onClick={onRedirectForCreatePatient}
            >
              <PlusOutlined className="m-0 me-md-2" />
              <span className="d-none d-md-inline-block">Add Patient</span>
            </button>
          </div>
        ) : (
          <>
            <h3 class="mb-3">
              Journey{" "}
              <span className="patient-name">{`(${
                patient?.patient_full_name ?? ""
              })`}</span>
            </h3>
            <div class="timeline">
              {completed_pages?.map((module, index) => {
                return module.entries.map((item) => {
                  return (
                    <div
                      class={`timeline-card ${
                        index % 2 === 0 ? "right" : "left"
                      }`}
                    >
                      <div class="date">
                        {formatDateToDDMMYYYY(item.created_at)}
                      </div>
                      <div class="icon">
                        <img src={handleModuleWiseIcon(module.icon)} alt="" />
                      </div>
                      <div class="content">
                        <h2>
                          <div className="checked-icon">
                            <img src={CheckedIcon} alt="" />
                          </div>
                          {`${module.name} ${item?.ivf_id ?? ""}`}
                        </h2>
                        <div class="timeline-event">
                          <button
                            onClick={() =>
                              handleEditModuleForSelectedPatient(module, item)
                            }
                          >
                            <img src={EditIconImg} alt="" />{" "}
                          </button>
                          {module?.icon !== 15 && (
                            <button>
                              <img
                                src={ViewIconImg}
                                alt=""
                                onClick={() => onShowModuleDetail(module, item)}
                              />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                });
              })}

              <button
                className="btn_border next_step_btn"
                onClick={moduleRedirectOnNextStep}
              >
                Next Step
                <img src={RightArrowImg} alt="" />{" "}
              </button>
            </div>

            {activeModuleEntry === "Patient Registration" && (
              <PatientRegistrationModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Patient Basic History" && (
              <PatientBasicHistoryModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Patient Extended History" && (
              <PatientExtendedHistoryModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Male Infertility Investigation" && (
              <MaleInfertilityInvestigationModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Female Infertility Investigation" && (
              <FemaleInfertilityInvestigationModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "IVF Flow Sheet" && (
              <IvfFlowSheetModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Embryology Data Sheet" && (
              <EmbryologyDataSheetModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Semen Analysis" && (
              <SemenAnalysisModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Sperm Freezing" && (
              <SFreezingModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Sperm DFI" && (
              <DNAModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "IUI" && (
              <IUIModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "SST" && (
              <SSTModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Discharge Summary" && (
              <DischargeCardModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Luteal Phase" && (
              <LutealPhaseModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Embryo Bank" && (
              <EmbryoBankModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Cycle Out Come" && (
              <CycleOutComeModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "PGT Discharge Card" && (
              <PGTDischargeCardModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "TESA/PESA Discharge Card" && (
              <TesaPesaDischargeCardModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default memo(PhasePatientList);
